/* gg-collezione.js · 7/10/2026 (Claude, blocco 4 del cantiere) · è il JS di build_collezioni.py portato nel tema: nasconde (le chip e la
   ricerca), riordina (il select) e conta. Le card stanno già nell'HTML; qui si tocca solo l'ordine e la visibilità.
   L'ordine del venduto: se la pagina non è già in quell'ordine (data-sort), lo chiede a Shopify con ?view=rango&sort_by=best-selling
   (templates/collection.rango.liquid risponde coi soli handle) e riordina — la griglia resta invisibile finché non arriva, al massimo 2 s,
   così non salta sotto gli occhi. Lo stato nell'URL come su Netlify: ?cerca=1 mette il cursore nel campo (è dove porta la lente), ?filtro=
   ?q= ?ordina= rimettono una scelta. */
(function () {
  function init(root) {
    if (root.dataset.ggInit) return; root.dataset.ggInit = '1';
    var griglia = root.querySelector('[data-griglia]'); if (!griglia) return;
    var cards = Array.prototype.slice.call(griglia.querySelectorAll('.gg-card')), totale = cards.length;
    var conta = root.querySelector('.n-vivo'), sel = root.querySelector('[data-ordina]'), vuoto = root.querySelector('.vuoto');
    var form = root.querySelector('form.cerca'), cerca = form && form.querySelector('input'), x = form && form.querySelector('.cerca-x');
    var chips = Array.prototype.slice.call(root.querySelectorAll('.filtri .chip')), filtro = 'tutti';
    // 27/10/2026 (Idee regalo): la chip accesa nell'HTML è quella di partenza (le fasce di prezzo non hanno «Tutti») e non va nell'URL;
    // con data-solo-n il conteggio dice «18 gioiellini» e non «18 gioiellini su 33»
    var accesa = root.querySelector('.filtri .chip.on'); if (accesa) filtro = accesa.dataset.filtro;
    var base = filtro, soloN = root.hasAttribute('data-solo-n');
    function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim(); }
    cards.forEach(function (c, i) { c.dataset.cerca = norm(c.dataset.cerca); if (!c.dataset.rango) c.dataset.rango = i; });
    function gioiellini(n) { return n + (n === 1 ? ' gioiellino' : ' gioiellini'); }
    function url() {
      try {
        var p = new URLSearchParams(location.search);
        ['filtro', 'q', 'ordina', 'cerca'].forEach(function (k) { p.delete(k); });
        if (filtro !== base) p.set('filtro', filtro);
        if (cerca && cerca.value) p.set('q', cerca.value);
        if (sel && sel.value !== 'venduti') p.set('ordina', sel.value);
        var s = p.toString(); history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
      } catch (e) {}
    }
    function applica() {
      var tok = norm(cerca ? cerca.value : '').split(' ').filter(Boolean), n = 0;
      cards.forEach(function (c) {
        var ok = filtro === 'tutti' || (' ' + (c.dataset.f || '') + ' ').indexOf(' ' + filtro + ' ') >= 0;
        if (ok && tok.length) { var t = c.dataset.cerca || ''; ok = tok.every(function (w) { return t.indexOf(w) >= 0; }); }
        c.hidden = !ok; if (ok) n++;
      });
      if (conta) conta.textContent = n === totale || soloN ? gioiellini(n) : gioiellini(n) + ' su ' + totale;
      if (vuoto) vuoto.hidden = n > 0;
      if (x) x.hidden = !(cerca && cerca.value);
      url();
    }
    function ordina() {
      var m = sel ? sel.value : 'venduti';
      cards.slice().sort(function (a, b) {
        var pa = +a.dataset.prezzo, pb = +b.dataset.prezzo, r = a.dataset.rango - b.dataset.rango;
        return m === 'prezzo-su' ? (pa - pb || r) : m === 'prezzo-giu' ? (pb - pa || r) : r;
      }).forEach(function (c) { griglia.appendChild(c); });
      url();
    }
    function scegli(k) { filtro = k; chips.forEach(function (c) { var on = c.dataset.filtro === k; c.classList.toggle('on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); }); applica(); }
    chips.forEach(function (c) { c.addEventListener('click', function () { scegli(c.dataset.filtro); }); });
    if (sel) sel.addEventListener('change', ordina);
    if (cerca) { cerca.addEventListener('input', applica); form.addEventListener('submit', function (ev) { ev.preventDefault(); cerca.blur(); }); }
    if (x) x.addEventListener('click', function () { cerca.value = ''; applica(); cerca.focus(); });
    if (vuoto) { var va = vuoto.querySelector('a'); if (va) va.addEventListener('click', function (ev) { ev.preventDefault(); if (cerca) cerca.value = ''; scegli(base); }); }
    var q = new URLSearchParams(location.search);
    if (sel && q.get('ordina') && sel.querySelector('option[value="' + q.get('ordina') + '"]')) sel.value = q.get('ordina');
    if (cerca && q.get('q')) cerca.value = q.get('q');
    var f = q.get('filtro'); if (f && chips.some(function (c) { return c.dataset.filtro === f; })) filtro = f;

    // l'ordine di partenza: il venduto, chiesto a Shopify se la pagina non è già così
    // dopo il riordino le prime quattro card in vista non restano lazy (Lighthouse: l'LCP caricato in ritardo), le prime due hanno la precedenza
    function sveglia() { Array.prototype.slice.call(griglia.querySelectorAll('.gg-card')).filter(function (c) { return !c.hidden; }).slice(0, 4).forEach(function (c, i) { var im = c.querySelector('img'); if (!im) return; im.loading = 'eager'; if (i < 2) im.setAttribute('fetchpriority', 'high'); }); }
    // 20/10/2026 (Luca, il post di Sotto lo stesso Sole, Luna): i prodotti «In testa» (data-in-testa, solo su /collections/all) passano davanti
    // a tutti, nell'ordine scritto; gli altri tengono il loro posto nel venduto
    var inTesta = (griglia.dataset.inTesta || '').split(',').filter(Boolean);
    function testa() { cards.forEach(function (c) { var i = inTesta.indexOf(c.dataset.handle); if (i >= 0) c.dataset.rango = i - 10000; }); }
    function pronta() { testa(); ordina(); scegli(filtro); sveglia(); griglia.classList.remove('gg-attesa'); }
    var vuoleVenduto = griglia.dataset.ordine === 'venduti', giaVenduto = griglia.dataset.sort === 'best-selling';
    if (vuoleVenduto && !giaVenduto && griglia.dataset.rangoUrl && totale > 1) {
      var fatto = false, fine = function () { if (fatto) return; fatto = true; pronta(); };
      setTimeout(fine, 2000);
      // l'ordine si ricorda per la sessione (tornando da una scheda non si aspetta); la prima volta la pagina lo precarica con <link rel=preload>
      var chiave = 'gg-rango:' + griglia.dataset.rangoUrl, dallaCache = null;
      try { dallaCache = sessionStorage.getItem(chiave); } catch (e) {}
      function applicaOrdine(t) {
        var ord = {}; t.replace(/\s+/g, '').split(',').forEach(function (h, i) { if (h) ord[h] = i; });
        if (Object.keys(ord).length) cards.forEach(function (c) { c.dataset.rango = c.dataset.handle in ord ? ord[c.dataset.handle] : 1000 + (+c.dataset.rango); });
      }
      if (dallaCache) { applicaOrdine(dallaCache); fine(); }
      else fetch(griglia.dataset.rangoUrl, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
        applicaOrdine(t); try { if (t) sessionStorage.setItem(chiave, t); } catch (e) {}
        fine();
      }).catch(fine);
    } else pronta();
    if (cerca && q.get('cerca')) { window.scrollTo(0, form.getBoundingClientRect().top + window.pageYOffset - 12); cerca.focus({ preventScroll: true }); }
  }
  function boot() { document.querySelectorAll('[data-gg-collezione]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
